import { render, staticRenderFns } from "./AddTitleToVideoModal.vue?vue&type=template&id=047b0e1a&scoped=true&"
import script from "./AddTitleToVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddTitleToVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTitleToVideoModal.vue?vue&type=style&index=0&id=047b0e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b0e1a",
  null
  
)

export default component.exports